import { useState } from 'react';
import './UploadShapefile.css';

import Navbar from '../../components/Navbar/Navbar';
import API_URL from '../../config/api';
import { toast, ToastContainer } from 'react-toastify';
import { getUsername } from '../../utils/auth';
import Footer from '../../components/Footer/Footer';
import { CircularProgress } from '@mui/material';

const gruposCamadas = {
  "Andamento dos Produtos": {
    "Recobrimento Aerofotogramétrico": "ctrl_aerofotogrametrico",
    "Apoio de Campo - Classe II - PCL": "ctrl_apoio_de_campo_2_pcl",
    "Apoio de Campo - Classe II - HV e PCA": "ctrl_apoio_de_campo_2_hv_pca",
    "Fotoíndice": "ctrl_fotoindice",
    "Perfilamento a LASER Aerotransportado": "ctrl_laser",
    "Classificação da Nuvem de Pontos": "ctrl_class_nuvem_de_pontos",
    "Modelo Digital de Superficie - MDS": "ctrl_mds",
    "Modelo Digital de Terreno - MDT": "ctrl_mdt",
    "Imagem Hipsometricas": "ctrl_img_hipsometrica",
    "Imagem de Intensidade": "ctrl_img_intensidade",
    "Aerotriangulação": "ctrl_aerotriangulacao",
    "Ortofotomosaico RGB/NIR": "ctrl_ortofotomosaico",
    "Curvas de Nível": "ctrl_curva_de_nivel",
    "Base Hidrográfica": "ctrl_base_hidrografica",
    "Base Hidrográfica Ottocodificada": "ctrl_base_hidrografica_ottocodificada",
    "Restituição Planimétrica": "ctrl_restituicao_planimetrica",
    "Reambulação": "ctrl_reambulacao",
    "Edição Gráfica": "ctrl_edicao",
  },
  "Informações Gerais": {
    "Articulação Sistemática 1:5.000": "info_articulacao_sistematica_1_5000",
    "Articulação Sistemática 1:10.000": "info_articulacao_sistematica_1_10000",
    "Articulação Sistemática 1:25.000": "info_articulacao_sistematica_1_25000",
    "Articulação Auxiliar 1:5.000": "info_articulacao_auxiliar_1_5000",
    "Articulação Auxiliar 1:10.000": "info_articulacao_auxiliar_1_10000",
    "Blocos de Entrega": "info_bloco_entrega",
    "Limite Estadual": "info_limite_pr",
    "Área de Abrangência do Projeto": "info_limite_pr_2km",
    "Limite Municipais": "info_limite_municipais",
    "Lotes do Projeto": "info_lote_projeto",
    "Caminho do Peabiru": "info_caminho_perabiru",
  },
  "Informações de Voo": {
    "Aeroporto": "info_aeroporto",
    "Bases de Voo": "info_base_voo",
    "Raio das Bases de Voo": "info_raio_base_voo",
    "RBMC": "info_rbmc",
    "GPS": "info_gps",
    "RN": "info_rn"
  },
  "Base de Dados": {
    "Bacias IAT": "info_bacia_iat",
    "Nível de Dificuldade": "info_nivel_dificuldade",
    "Rodovias": "info_rodovia",
    "Hidrografia": "info_hidrografia",
    "Camada de Áreas Urbanas": "info_area_urbana",
    "Camada de Declividade": "info_declividade",
    "Camada de Manchas de Clima": "info_mancha_clima",
    "Camada de Precipitacção": "info_precipitacao",
    "Camada de Rede Geodésica": "info_geodesica",
    "Camada de Relevo": "info_relevo",
    "Camada de Vegetação": "info_vegetacao"
  }
};

const UploadShapefile = () => {
  const [file, setFile] = useState(null);
  const [selectedLayerName, setSelectedLayerName] = useState('');
  const [descricao, setDescricao] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const [expandedGroups, setExpandedGroups] = useState(() =>
    Object.keys(gruposCamadas).reduce((acc, grupo) => {
      acc[grupo] = false;
      return acc;
    }, {})
  );

  const toggleGroup = (grupo) => {
    setExpandedGroups(prev => ({
      ...prev,
      [grupo]: !prev[grupo]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      return toast.warn("Selecione um arquivo .rar/.zip para upload.");
    }
    if (!selectedLayerName) {
      return toast.warn("Selecione uma camada marcando um dos checkboxes.");
    }

    let groupKey = "";
    let layerKey = "";
    let tableName = "";
    for (const [grpKey, layers] of Object.entries(gruposCamadas)) {
      for (const [lyrKey, lyrValue] of Object.entries(layers)) {
        if (lyrKey === selectedLayerName) {
          groupKey = grpKey;
          layerKey = lyrKey;
          tableName = lyrValue;
          break;
        }
      }
      if (tableName) break;
    }

    if (!tableName) {
      return toast.error("Nome da tabela não mapeado.");
    }

    const token = JSON.parse(atob(localStorage.getItem('token') || '""'));
    const formData = new FormData();

    formData.append('file', file);
    formData.append('usuarioUpload', getUsername());
    formData.append('descricao', descricao.trim() || "");
    formData.append('grupoLayer', groupKey);
    formData.append('nomeLayer', layerKey);

    try {
      setIsLoading(true);
      await new Promise(res => setTimeout(res, 1000));

      const response = await fetch(`${API_URL}/api/layers/upload?tableName=${encodeURIComponent(tableName)}`, {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });

      if (response.ok) {
        const result = await response.text();
        toast.success(result || "Shapefile enviado com sucesso!");
      }
      else {
        const errorText = await response.text();
        toast.error(`Erro ao importar: ${errorText}`);
      }
    }
    catch (error) {
      toast.error(`Erro de conexão: ${error.message}`);
    }
    finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {
        isLoading && (
          <div className="loading-overlay">
            <div style={{ textAlign: 'center' }}>
              <CircularProgress size={60} thickness={5} />
              <p style={{ marginTop: '10px', fontSize: '16px', color: '#233777' }}>
                Enviando shapefile...
              </p>
            </div>
          </div>
        )
      }
      <div className="page-layout">
        <Navbar />
        <ToastContainer position="top-right" autoClose={3000} />

        <div className="page-content">
          <form onSubmit={handleSubmit} className="upload-container">
            <h2>Upload de Shapefile (.zip)</h2>

            <label>Arquivo (.rar ou .zip com .shp, .dbf, .shx):</label>
            <input
              type="file"
              accept=".zip,.rar"
              onChange={(e) => setFile(e.target.files[0])}
            />

            <label>Selecione a Camada:</label>
            <div className="grid-checkboxes">
              {Object.entries(gruposCamadas).map(([grupo, camadas]) => (
                <div key={grupo} className="checkbox-column">
                  <strong
                    onClick={() => toggleGroup(grupo)}
                    style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                  >
                    {grupo}
                    <span>{expandedGroups[grupo] ? '−' : '+'}</span>
                  </strong>

                  {expandedGroups[grupo] && Object.entries(camadas).map(([label, table]) => (
                    <label key={label} className="checkbox-label">
                      <input
                        type="checkbox"
                        checked={selectedLayerName === label}
                        onChange={() => setSelectedLayerName(label)}
                      />
                      {label}
                    </label>
                  ))}
                </div>
              ))}
            </div>

            <div className="descricao-wrapper">
              <label htmlFor="descricao">Descrição:</label>
              <textarea
                id="descricao"
                value={descricao}
                onChange={(e) => setDescricao(e.target.value)}
                placeholder="Resumo da mudança..."
                rows={4}
                cols={65}
              />
            </div>

            <div className='buttom-container'>
              <button type="submit" disabled={isLoading}>
                {isLoading ? "Enviando..." : "Enviar"}
              </button>
            </div>

          </form>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default UploadShapefile;